import axios from "axios";

export default class MenuService {
    getData() {
        return axios.get('/menus/list_all_menus',)
            .then(res => res.data);
    }
}
